import { createWidget } from '@alfa-bank/site-util-create-widget';
import { SelectDesktop as Select } from '@alfalab/core-components-select/desktop';
import { BaseOption as Option } from '@alfalab/core-components-select/shared';
import { useSelectWithApply } from '@alfalab/core-components-select/presets';

import { useControlled } from '../hooks/use-controlled';
import type { TSelectV2DepsDesktop, TSelectV2Desktop } from '../models/desktop';

import { SelectV2DesktopRenderer as Component } from './select-v2';

export const SelectV2Desktop = createWidget<TSelectV2DepsDesktop, TSelectV2Desktop>(
    {
        Option,
        Select,
        useControlled,
        useSelectWithApply,
    },
    { priorityStyler: true }
)(Component);
